import { Component, OnInit } from '@angular/core';
import { TarjetasService } from 'src/app/service/tarjetas.service';
import { LoginService } from 'src/app/service/login.service';
import { PerfilService } from 'src/app/service/perfil.service';
import { Session } from 'protractor';


@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.scss']
})
export class SolicitudesComponent implements OnInit {
  modal = false;
  session: any;
  solicitudes: any[] = [];
  cardSelected: any
  numeroSolicitud: any;
  user: any
  dni: any
  detalleSolicitud: any;
  fecha: any;
  errorMensaje: any;

  constructor(private tarjetas: TarjetasService, private perfil: PerfilService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    this.dni = this.session.dpi
  }

  ngOnInit() {
    this.tarjetas.selectedCard.subscribe(tarjetas => {
      this.cardSelected = tarjetas;
      this.getData();
    });
  }

  detalles(solicitud, tipo, fecha) {
    this.numeroSolicitud = solicitud;
    this.fecha = fecha;
    let json = {
      KSI: this.session.idSession,
      numSolicitud: solicitud,
      codTipoSolicitud: tipo
    }
    this.tarjetas.getDetalle(json).subscribe(res => {
      this.detalleSolicitud = res
      this.show(true);
    }, () => {
      this.errorMensaje = "Error al obtener el detalle. Inténtelo más tarde.";
    })
  }

  getData() {
    let body = {
      run: this.dni
    }
    this.tarjetas.getSolicitudes(body).subscribe(res => {
      this.solicitudes = res.curSolicitudes;
    }, () => {
      this.errorMensaje = "Error al obtener solicitudes. Inténtelo más tarde.";
    })
  }

  show(response: boolean) {
    this.modal = response;
  }
}
